import AccountBalanceOutlined from '@mui/icons-material/AccountBalanceOutlined';
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined';
import BusinessOutlined from '@mui/icons-material/BusinessOutlined';
import DashboardOutlined from '@mui/icons-material/DashboardOutlined';
import PeopleOutline from '@mui/icons-material/PeopleOutline';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import StorageOutlined from '@mui/icons-material/StorageOutlined';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import { typedMemo } from '@utils';
import { NavigationProvider } from './NavigationContext';
import { NavigationMenuItem } from './NavigationMenuItem';

interface NavigationMenuProps {
  onItemClick?: () => void;
}

export const NavigationMenu = typedMemo(
  ({ onItemClick }: Readonly<NavigationMenuProps>) => {
    return (
      <NavigationProvider onItemClick={onItemClick}>
        <Box sx={{ width: '15.625rem' }}>
          <List>
            <NavigationMenuItem text="Allgemein" icon={<DashboardOutlined />}>
              <NavigationMenuItem
                target="/"
                text="Projektverwaltung"
                icon={<AssignmentOutlined />}
              />
              <NavigationMenuItem text="Stammdaten" icon={<StorageOutlined />}>
                <NavigationMenuItem
                  target="/business-partner"
                  text="Geschäftspartner"
                  icon={<PeopleOutline />}
                />
                <NavigationMenuItem
                  target="/organization"
                  text="Organisation"
                  icon={<AccountBalanceOutlined />}
                />
              </NavigationMenuItem>
            </NavigationMenuItem>

            <NavigationMenuItem text="Projekt" icon={<BusinessOutlined />}>
              {/* Hier können Projekt-Menüpunkte hinzugefügt werden */}
            </NavigationMenuItem>

            <NavigationMenuItem
              text="Administration"
              icon={<SettingsOutlined />}
            >
              {/* Hier können Administrations-Menüpunkte hinzugefügt werden */}
            </NavigationMenuItem>
          </List>
        </Box>
      </NavigationProvider>
    );
  },
);
